import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  onNext: () => void;
  onPrev: () => void;
  isNextFetching?: boolean;
  isPrevFetching?: boolean;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({
  isNextFetching,
  isPrevFetching,
  currentPage,
  totalPages,
  onNext,
  onPrev,
}) => {
  return totalPages <= 0 ? (
    <div></div>
  ) : (
    <div className="flex justify-between items-center mt-6">
      {totalPages > 0 && (
        <div className="text-sm text-gray-500">
          Page {currentPage} of {totalPages}
        </div>
      )}

      <div className="flex items-center gap-2">
        <button
          onClick={onPrev}
          disabled={isPrevFetching || currentPage === 1 || totalPages === 0}
          className="inline-flex items-center gap-1 px-3 py-1.5 text-sm text-gray-600 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors font-normal disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-white"
        >
          <ChevronLeft className="w-4 h-4" />
          {isPrevFetching ? "Loading..." : "Previous"}
        </button>

        <button
          onClick={onNext}
          disabled={
            isNextFetching || totalPages === 0 || currentPage === totalPages
          }
          className="inline-flex items-center gap-1 px-3 py-1.5 text-sm text-gray-600 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors font-normal disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-white"
        >
          {isNextFetching ? "Loading..." : "Next"}
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default PaginationControls;
